import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "addressContainer" }
const _hoisted_2 = {
  key: 0,
  class: "lowTitle"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = { class: "form-group col-sm-10" }
const _hoisted_6 = { class: "control-label" }
const _hoisted_7 = {
  key: 0,
  class: "form-control"
}
const _hoisted_8 = { class: "form-group col-sm-2" }
const _hoisted_9 = { class: "control-label" }
const _hoisted_10 = {
  key: 0,
  class: "form-control"
}
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "form-group col-md-4" }
const _hoisted_13 = { class: "control-label" }
const _hoisted_14 = {
  key: 0,
  class: "form-control"
}
const _hoisted_15 = { class: "form-group col-md-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "control-label" }, "Regione", -1)
const _hoisted_17 = {
  key: 0,
  class: "form-control"
}
const _hoisted_18 = { class: "form-group col-md-4" }
const _hoisted_19 = { class: "control-label" }
const _hoisted_20 = {
  key: 0,
  class: "form-control"
}
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "form-group col-8" }
const _hoisted_23 = { class: "control-label" }
const _hoisted_24 = {
  key: 0,
  class: "form-control"
}
const _hoisted_25 = { class: "form-group col-4" }
const _hoisted_26 = { class: "control-label" }
const _hoisted_27 = {
  key: 0,
  class: "form-control"
}
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = { class: "control-label" }
const _hoisted_30 = {
  key: 0,
  class: "form-control"
}
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = { class: "control-label" }
const _hoisted_33 = {
  key: 0,
  class: "form-control"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_google_autocomplete = _resolveComponent("google-autocomplete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_localized_text, {
            localizedKey: _ctx.label,
            text: _ctx.label
          }, null, 8, ["localizedKey", "text"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_google_autocomplete, {
          modelValue: _ctx.googleAddress,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.googleAddress) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("label", _hoisted_6, [
          _createVNode(_component_localized_text, {
            localizedKey: "Via",
            text: "Via"
          })
        ]),
        (_ctx.readonly)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.localValue.via || '-'), 1))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              class: "form-control",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localValue.via) = $event))
            }, null, 512)), [
              [_vModelText, _ctx.localValue.via]
            ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("label", _hoisted_9, [
          _createVNode(_component_localized_text, {
            localizedKey: "Civico",
            text: "Civico"
          })
        ]),
        (_ctx.readonly)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.localValue.civico || '-'), 1))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              class: "form-control",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localValue.civico) = $event))
            }, null, 512)), [
              [_vModelText, _ctx.localValue.civico]
            ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("label", _hoisted_13, [
          _createVNode(_component_localized_text, {
            localizedKey: "Città",
            text: "Città"
          })
        ]),
        (_ctx.readonly)
          ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.localValue.citta || '-'), 1))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              class: "form-control",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localValue.citta) = $event))
            }, null, 512)), [
              [_vModelText, _ctx.localValue.citta]
            ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        (_ctx.readonly)
          ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.localValue.regione || '-'), 1))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              class: "form-control",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localValue.regione) = $event))
            }, null, 512)), [
              [_vModelText, _ctx.localValue.regione]
            ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("label", _hoisted_19, [
          _createVNode(_component_localized_text, {
            localizedKey: "Nazione",
            text: "Nazione"
          })
        ]),
        (_ctx.readonly)
          ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.localValue.nazione || '-'), 1))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              class: "form-control",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localValue.nazione) = $event))
            }, null, 512)), [
              [_vModelText, _ctx.localValue.nazione]
            ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("label", _hoisted_23, [
          _createVNode(_component_localized_text, {
            localizedKey: "Provincia",
            text: "Provincia"
          })
        ]),
        (_ctx.readonly)
          ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.localValue.provincia || '-'), 1))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              class: "form-control",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.localValue.provincia) = $event))
            }, null, 512)), [
              [_vModelText, _ctx.localValue.provincia]
            ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("label", _hoisted_26, [
          _createVNode(_component_localized_text, {
            localizedKey: "CAP",
            text: "CAP"
          })
        ]),
        (_ctx.readonly)
          ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.localValue.cap || '-'), 1))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              class: "form-control",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.localValue.cap) = $event))
            }, null, 512)), [
              [_vModelText, _ctx.localValue.cap]
            ])
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("label", _hoisted_29, [
        _createVNode(_component_localized_text, {
          localizedKey: "Scala, piano, interno ecc.",
          text: "Scala, piano, interno ecc."
        })
      ]),
      (_ctx.readonly)
        ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.localValue.scalaPianoInterno || '-'), 1))
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            class: "form-control",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.localValue.scalaPianoInterno) = $event))
          }, null, 512)), [
            [_vModelText, _ctx.localValue.scalaPianoInterno]
          ])
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("label", _hoisted_32, [
        _createVNode(_component_localized_text, {
          localizedKey: "Note per spedizioni",
          text: "Note per spedizioni"
        })
      ]),
      (_ctx.readonly)
        ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.localValue.note || '-'), 1))
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            class: "form-control",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.localValue.note) = $event))
          }, null, 512)), [
            [_vModelText, _ctx.localValue.note]
          ])
    ])
  ]))
}